import http from 'http/http';
import { api } from 'http/helpers';
import URLS from 'http/urls';

import { SptStartVideoData } from './types';

export const sptAppearanceApi = {
  fetchStartVideoData() {
    return http.get<SptStartVideoData>(api(URLS.sptAppearance.video), {
      skipHttpErrorHandler: true,
    });
  },

  uploadStartVideo(data: FormData) {
    return http.post<FormData, SptStartVideoData>(
      api(URLS.sptAppearance.video),
      data,
      {
        headers: {
          Accept: '*/*',
          'Content-type': 'multipart/form-data',
        },
      },
    );
  },

  deleteStartVideo() {
    return http.delete(api(URLS.sptAppearance.video));
  },

  fetchLogo() {
    return http.get<string>(api(URLS.sptAppearance.logo), {
      skipHttpErrorHandler: true,
    });
  },

  uploadLogo(data: FormData) {
    return http.post<FormData, string>(api(URLS.sptAppearance.logo), data, {
      headers: {
        Accept: '*/*',
        'Content-type': 'multipart/form-data',
      },
    });
  },

  deleteLogo() {
    return http.delete(api(URLS.sptAppearance.logo));
  },

  fetchText() {
    return http.get<string>(api(URLS.sptAppearance.text), {
      skipHttpErrorHandler: true,
    });
  },

  updateText(text: string) {
    return http.post<null, string>(api(URLS.sptAppearance.text), null, {
      params: { text },
    });
  },

  deleteText() {
    return http.delete(api(URLS.sptAppearance.text));
  },
};
